export default __webpack_public_path__ + "static/diptnc_blogs_black_logo-8f6f3549576611f1156ea8ab6cae4570.svg";